import React from 'react';

import { useProfileState, useProfileActions } from './ProfileContext';

import Divider from '../../Shared/UI/Divider/components/Divider';
import Button from '../../Shared/UI/Button/components/Button';
import PlusIcon from '../../Shared/UI/PlusIcon/components/PlusIcon';
import ProfileUserCertification from './ProfileUserCertification';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import NewUserCertificationForm from './NewUserCertificationForm';
import UpdateUserCertificationForm from './UpdateUserCertificationForm';
import DeleteUserCertificationForm from './DeleteUserCertificationForm';

import styles from './ProfileUserCertifications.module.scss';

const ProfileUserCertifications = () => {
  const state = useProfileState();
  const { openNewUserCertificationModal, closeNewUserCertificationModal, closeUpdateUserCertificationModal, closeDeleteUserCertificationModal } = useProfileActions();

  const titleStyling = state?.user?.certifications?.length ? null : styles.visibleOnlyToYou;

  if (state.loading) {
    return (
      <section id={styles.userCertificationsSection}>
        <Divider />
        <div id={styles.userCertificationsLoading} />
      </section>
    );
  }

  return (
    <>
      {(state?.user?.certifications?.length || state?.user?.isAuthenticatedUser) && (
        <section id={styles.userCertificationsSection}>
          <Divider />
          <div id={styles.userCertificationsSectionHeader}>
            <h2 className={titleStyling}>
              Certifications
            </h2>
            {state?.user?.isAuthenticatedUser && (
              <Button
                variant="ghost"
                icon={<PlusIcon />}
                iconOnly
                aria-label="Add Certification"
                onClick={() => {
                  if (state?.user?.isAuthenticatedUser) {
                    openNewUserCertificationModal();
                  }
                }}
              />
            )}
          </div>
          {state?.user?.certifications?.length ? (
            <div id={styles.userCertifications}>
              {state?.user?.certifications?.map((certification, index) => {
                if (index === state?.user?.certifications.length - 1) {
                  return <ProfileUserCertification key={certification.id} certification={certification} />;
                }

                return (
                  <React.Fragment key={certification.id}>
                    <ProfileUserCertification certification={certification} />
                    <Divider variant="secondary"/>
                  </React.Fragment>
                );
              })}
            </div>
          ) : (
            <p className={styles.visibleOnlyToYou}>
              This section is currently only visible to you since you have not added any certifications to display yet.
            </p>
          )}
        </section>
      )}
      <StandardModal
        isOpen={state?.newUserCertificationModalIsOpen}
        contentLabel={'Add Your Certification'}
        onRequestClose={() => {
          if (state?.user?.isAuthenticatedUser) {
            closeNewUserCertificationModal();
          }
        }}
      >
        <NewUserCertificationForm />
      </StandardModal>
      <StandardModal
        isOpen={state?.updateUserCertificationModalIsOpen}
        contentLabel={'Update Your Certification'}
        onRequestClose={() => {
          if (state?.user?.isAuthenticatedUser) {
            closeUpdateUserCertificationModal();
          }
        }}
      >
        <UpdateUserCertificationForm />
      </StandardModal>
      <StandardModal
        isOpen={state?.deleteUserCertificationModalIsOpen}
        contentLabel={'Delete This Certification'}
        onRequestClose={() => {
          if (state?.user?.isAuthenticatedUser) {
            closeDeleteUserCertificationModal();
          }
        }}
      >
        <DeleteUserCertificationForm />
      </StandardModal>
    </>
  );
};

export default ProfileUserCertifications;
